
import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";

@autoinject
export class MoistureFormatValueConverter {

	constructor(private i18n: I18N) { }
	toView(moisture: number) {
		if (moisture === null || moisture === undefined || isNaN(moisture)) {
			return this.i18n.tr("offline");
		}
		return `${moisture.toFixed(2)} %`;
	}
}